<template>
  <div v-loading="loading">
    <el-card class="box-card" id="profession">
        <div class="option-list" style="z-index: 200">
          <el-row>
            <el-col :span="2">
              <div class="titlt-position">
                专业：
              </div>
            </el-col>
            <el-col :span="22">
              <el-menu :default-active="activeProfession"
                       mode="horizontal"
                       @select="handleSelectpProfession"
                       text-color="#333333"
                       active-text-color="#409EFF"
                       style="margin-left: -10px">
                <el-menu-item index="">全部</el-menu-item>
                <el-menu-item :index="profession.id" v-for="(profession,i) in professionList" :key="profession.id">
                  {{profession.name}}
                </el-menu-item>
              </el-menu>
            </el-col>
          </el-row>
        </div>
        <div class="option-list project-option-list" style="z-index: 100">
          <el-row>
            <el-col :span="2">
              <div class="titlt-position">
                项目：
              </div>
            </el-col>
            <el-col :span="22">
              <el-menu :default-active="activeProject"
                       mode="horizontal"
                       @select="handleSelectpProject"
                       text-color="#333333"
                       active-text-color="#409EFF"
                       style="margin-left: -10px">
                <el-menu-item index="">全部</el-menu-item>
                <el-menu-item :index="project.id"  v-for="(project,i) in projectList" :key="project.id">
                  {{project.name}}
                </el-menu-item>
              </el-menu>
            </el-col>
          </el-row>
        </div>
    </el-card>
    <!-- 图形卡片-->
    <el-row  style="margin-top: 40px;width: 1200px">
      <el-col :span="6" v-for="(item,i) in courseList" :key="item.id" :offset="i%4 > 0 ? 1 : 0"  v-if="total > 0">
        <cart :item="item"></cart>
      </el-col>
      <el-col style="text-align: center" v-if="total == 0">
        <img src="@/assets/img/none.png" width="400" height="400" alt="">
      </el-col>
    </el-row>

    <!-- 分页-->
    <div style="text-align: center">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size.sync="pageSize"
        :current-page.sync="pageNum"
        @current-change="getCourseList"
        :total="total"
        v-if="total > 0">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import cart from '@/components/course/Cart'
  export default {
    name: "CourseList",
    components: {
      cart
    },
    props: {
      courseType: String,
      name: String
    },
    data() {
      return {
        // id
        activeProfession: '',
        activeProject: '',
        // 专业列表
        professionList: [],
        // 项目列表
        projectList: [],
        courseList: [],
        pageNum: 1,
        pageSize: 8,
        total: 0,  // 总页数
        loading:false
      }
    },
    watch:{
      name: function () {
        this.getCourseList(1);
      }
    },
    methods: {
      handleSelectpProfession(key, keyPath) {
        if (key === this.activeProfession) {
          return;
        }
        this.activeProfession = key;
        this.activeProject = '';
        this.getCourseList(1);
        this.getProjectList();
      },
      handleSelectpProject(key, keyPath) {
        if (key === this.activeProject) {
          return;
        }
        this.activeProject = key;
        this.getCourseList(1);
        const project = this.projectList.find(project => project.id === key);
        if (project) {
          this.activeProfession = project.professionId;
        }
        this.getProjectList();
      },
      async getProfessionList() {
        const {content} = await this.$http.get('/business/web/profession/list');
        this.professionList = content;
      },
      async getProjectList() {
        const {content} = await this.$http.get('/business/web/project/queryByProfessionId',{
          params: {professionId:this.activeProfession}
        });
        this.projectList = content;
      },
      async getCourseList(pageNo) {
        this.loading = true;
        const params = {
            courseType:this.courseType,
            name: this.name,
            page: pageNo ? pageNo : this.pageNum,
            size: this.pageSize,
            professionId: this.activeProfession,
            projectId: this.activeProject
        }
        const { content } = await this.$http.post('/business/web/course/pageList', params);
        this.courseList = content.records;
        this.pageNum = content.current;
        this.pageSize = content.size;
        this.total = content.total;
        this.loading = false;
      },
    },
    created() {

    },
    mounted() {
      // 获得专业列表
      this.getProfessionList();
      // 获得项目列表
      this.getProjectList();
      // 获得课程列表
      this.getCourseList(1);
    }
  }
</script>

<style lang="scss" scoped>

  .box-card {
    position: relative;
    width: 100%;
    height: 113px;
    overflow: inherit;
  }
  .el-card /deep/ .el-card__body {
    padding: 0;
  }
  #profession .el-menu--horizontal /deep/ .el-menu-item{
    font-size: 16px;
  }
  #profession .el-menu--horizontal /deep/ .el-menu-item.is-active{
    font-weight: 800;
  }
  .el-menu.el-menu--horizontal{
    border: none;
  }
  .titlt-position {
    margin: 12px;
    font-size: 16px;
    color: #606266;
    font-weight: bolder;
    text-align: center;
  }
  .image {
    width: 100%;
    display: block;
  }

  .option-list {
      position: absolute;
      max-height:40px;
      width: 1175px;
      padding: 5px 12px;
      border: 1px solid white;
      background-color: white;

      &:hover {
          border: 1px solid #dcdfe6;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          max-height: none;
          .el-menu {
              max-height: none;
          }
      }
  }
  .project-option-list {
    top: 56px;
  }

  .el-menu {
      max-height: 40px;
      overflow: hidden;
      user-select: none;
  }

  .el-menu-item {
      height: 40px;
      line-height: 45px;
      padding: 0 12px 0;
      font-size: 14px !important;
      &:hover {
          color: #3a8ee6 !important;
      }
      &.is-active {
          cursor: default;
      }
  }
  .el-col-6{
    width: 23.5%;
  }
  .el-col-offset-1{
    margin-left: 2%;
  }
  >>> .el-loading-mask{
    z-index: 900 !important;
  }
</style>
